import * as React from 'react';
import s from './AppHeader.scss';
import { withInjectedRootStore, RootStore } from 'providers';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import { Brands } from 'enums';
import WixStudioLogo from '../WixStudioApp/WixStudioAssets/wix-studio-logo.svg';
import EditorXLogo from '@wix/brand-resources/resources/EditorX/EditorX_logo_19x86_black.svg';
import { WixLogo } from '@wix/package-picker-components';
import DayfulLogo from '../../assets/images/dayful-logo.svg';
import classNames from 'classnames';

const LogoLink = {
  [Brands.DAYFUL]: 'https://www.dayful.com',
};
interface LogoProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

const LogoComp: React.FC<LogoProps> = ({ rootStore, experiments }) => {
  const { brand } = rootStore.appStore.appContext;
  const { shouldRenderWixStudioPackagePicker } = rootStore.appStore;
  const getLogo = () => {
    if (shouldRenderWixStudioPackagePicker) {
      return <WixStudioLogo />;
    }
    if (brand === Brands.EDITOR_X) {
      return <EditorXLogo />;
    }
    if (brand === Brands.DAYFUL) {
      return <DayfulLogo />;
    }
    return <WixLogo skin='dark' />;
  };
  const brandLink = LogoLink[brand];

  const redirectToBrandLink = () => {
    if (!brandLink) {
      return;
    }
    window.location.replace(brandLink);
  };

  return (
    <div className={s.logoWrapper}>
      <div
        className={classNames({
          [s.clickable]: !!brandLink,
        })}
        onClick={redirectToBrandLink}
        data-testid={`header-logo-${brand}`}
      >
        {getLogo()}
      </div>
    </div>
  );
};

export const Logo = withExperiments(withInjectedRootStore(LogoComp));
